const ProductDetailPage = () => ({
  initialOverflowStyle: "",
  compatibilityCharts: [],
  isCompatibilityModalOpen: false,
  defaultChart: "",
  toggleCompatibilityModal(defaultGuideToOpen) {
    document.querySelector("body").style.overflow = !this.isCompatibilityModalOpen
      ? "hidden"
      : this.initialOverflowStyle;

    this.isCompatibilityModalOpen = !this.isCompatibilityModalOpen;
    this.defaultChart = defaultGuideToOpen.toLowerCase() || "";
  },
  getCompatibilityData() {
    const tiresScript = document.querySelector("#js-data--compatibility-tires");
    const batteriesScript = document.querySelector("#js-data--compatibility-batteries");
    const chargersScript = document.querySelector("#js-data--compatibility-chargers");

    const tiresCompatibility = JSON.parse(tiresScript.innerText ?? null);
    const batteriesCompatibility = JSON.parse(batteriesScript.innerText ?? null);
    const chargersCompatibility = JSON.parse(chargersScript.innerText ?? null);

    return [tiresCompatibility, batteriesCompatibility, chargersCompatibility];
  },
  init() {
    // 1. Get compatibility data
    this.compatibilityCharts = this.getCompatibilityData();

    this.initialOverflowStyle = document.querySelector("body").style.overflow;
  }
});

export default ProductDetailPage;
